/* Momavo instant photo upload.
   Uploads a customer photo the moment it is picked (to the momavo-uploads Cloudflare worker, stored
   permanently in R2) and returns its URL. Product pages put that URL in the cart line as a text
   property, so Add to cart sends no files and is instant (one /cart/add.js call, even for a team).

   MomavoUpload.start(file, onProgress)  -> Promise<url>   starts (or reuses) the upload for this File;
                             optional onProgress(0..1) is called as bytes go up (and at once with the current value)
   MomavoUpload.get(file)    -> { state: 'uploading'|'done'|'error', url, progress (0..1), promise } or null
   MomavoUpload.wait(files)  -> Promise<url[]> waits for any still uploading, retries failed ones
   MomavoUpload.watch(input, onState)  uploads on every change of a file input; onState(state, url)

   Large JPEG/PNG/WebP photos (over 4 MB) are resized in the browser to 3600 px on the long edge
   (JPEG 92%), still far more than the print needs, so phone uploads finish in seconds.
   HEIC and anything the browser cannot decode is uploaded as is. */
(function () {
  if (window.MomavoUpload) return;
  var ENDPOINT = 'https://momavo-uploads.andyvo-co.workers.dev/upload';
  var MAX_EDGE = 3600, SHRINK_OVER = 4 * 1024 * 1024;
  var jobs = new WeakMap();

  function shrink(file) {
    if (file.size <= SHRINK_OVER || !/^image\/(jpeg|png|webp)$/.test(file.type) || !window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file, { imageOrientation: 'from-image' }).then(function (bmp) {
      var s = Math.min(1, MAX_EDGE / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (res) { c.toBlob(function (b) { res(b && b.size < file.size ? b : file); }, 'image/jpeg', 0.92); });
    }).catch(function () { return file; });
  }

  // XMLHttpRequest (not fetch) so the upload can report progress: onProgress(0..1)
  function send(file, onProgress) {
    return shrink(file).then(function (blob) {
      var type = blob.type || file.type || 'image/jpeg';
      if (/heic|heif/i.test(file.name) && !/heic|heif/.test(type)) type = 'image/heic';
      return new Promise(function (res, rej) {
        var x = new XMLHttpRequest();
        x.open('POST', ENDPOINT);
        x.setRequestHeader('Content-Type', type);
        x.setRequestHeader('X-File-Name', encodeURIComponent(file.name || 'photo'));
        x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
        x.onload = function () {
          if (x.status < 200 || x.status >= 300) return rej(new Error('upload ' + x.status));
          var d; try { d = JSON.parse(x.responseText); } catch (e) { d = null; }
          if (!d || !d.url) return rej(new Error('upload no url'));
          res(d.url);
        };
        x.onerror = x.ontimeout = x.onabort = function () { rej(new Error('upload network')); };
        x.send(blob);
      });
    });
  }

  function start(file, onProgress) {
    var j = jobs.get(file);
    if (!j || j.state === 'error') {
      j = { state: 'uploading', url: null, progress: 0, listeners: [] };
      var prog = function (p) { j.progress = Math.min(p, 0.99); j.listeners.forEach(function (fn) { fn(j.progress); }); };
      j.promise = send(file, prog).catch(function () { prog(0); return send(file, prog); }) // one automatic retry
        .then(function (url) { j.state = 'done'; j.url = url; j.progress = 1; j.listeners.forEach(function (fn) { fn(1); }); return url; },
              function (e) { j.state = 'error'; throw e; });
      jobs.set(file, j);
    }
    if (typeof onProgress === 'function' && j.listeners.indexOf(onProgress) < 0) { j.listeners.push(onProgress); onProgress(j.progress); }
    return j.promise;
  }

  window.MomavoUpload = {
    start: start,
    get: function (file) { return (file && jobs.get(file)) || null; },
    wait: function (files) { return Promise.all(files.map(function (f) { return start(f); })); },
    watch: function (input, onState) {
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (!f) return;
        onState && onState('uploading', null);
        start(f).then(function (url) { if (input.files[0] === f) onState && onState('done', url); },
                      function () { if (input.files[0] === f) onState && onState('error', null); });
      });
    }
  };
})();
